var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.431,
    height: 21.983,
    viewBox: "0 0 16.431 21.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.956,22.483h.011a.6.6,0,0,0,.584-.606l-.238-12.8a.6.6,0,0,0-.595-.584h-.011a.6.6,0,0,0-.584.606l.238,12.8A.6.6,0,0,0,21.956,22.483Zm3.481,0a.6.6,0,0,0,.595-.584l.238-12.8a.6.6,0,0,0-.584-.606h-.011a.6.6,0,0,0-.595.584l-.238,12.8a.6.6,0,0,0,.584.606Zm4.68-13.99a.6.6,0,0,0-.614.575l-.476,14.808a.731.731,0,0,1-.73.731H19.1a.737.737,0,0,1-.732-.751L17.89,9.068a.6.6,0,0,0-1.19.038l.476,14.77A1.924,1.924,0,0,0,19.1,25.8h9.2a1.919,1.919,0,0,0,1.92-1.9l.476-14.789A.6.6,0,0,0,30.116,8.493Zm1.2-2.38H27.58L27.2,4.289a.6.6,0,0,0-.583-.474H20.774a.6.6,0,0,0-.583.474l-.378,1.824H16.075a.595.595,0,0,0,0,1.19H31.316a.595.595,0,1,0,0-1.19Zm-10.287,0,.229-1.108h4.876l.229,1.108H21.029Z",
    transform: "translate(-15.48 -3.815)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ffdbad97c4c19df81aefee2079f7eaf0.svg";
export { ForwardRef as ReactComponent };